import { useTranslation } from "react-i18next";
import ScrollReveal from "./ScrollReveal";

const ValueProps = () => {
  const { t } = useTranslation();
  
  const values = [
    t('valueProps.value1'),
    t('valueProps.value2'),
    t('valueProps.value3'),
  ];

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-muted" aria-labelledby="value-props-heading">
      <div className="container mx-auto max-w-6xl">
        <h2 id="value-props-heading" className="sr-only">Core Values</h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12">
          {values.map((value, index) => (
            <ScrollReveal key={index} delay={index * 0.15} direction="up">
              <article className="text-center">
                <p className="text-xl sm:text-2xl md:text-3xl text-foreground font-semibold leading-relaxed">
                  {value}
                </p>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
